import { Col, Input, Row } from 'antd';
import PropTypes from 'prop-types';

export const TimeComponent = ({ value, onChange, disabledField, block }) => {
  const onChangeTime = (e) => {
    onChange(e.target.value || null);
  };

  return (
    <Row gutter={[10, 10]}>
      <Col xs={24} md={block ? 24 : 12}>
        <Input type="time" value={value ?? ''} onChange={onChangeTime} disabled={disabledField} />
      </Col>
    </Row>
  );
};

TimeComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabledField: PropTypes.bool,
  block: PropTypes.bool,

};
